import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import {
  Router,
  RouterEvent,
  NavigationEnd,
  ActivatedRoute,
} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { UnitsService } from 'src/app/core/services/units.service';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { UserService } from 'src/app/core/services/user.service';
import { SocketService } from 'src/app/core/services/socket.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import { IAlert } from 'src/app/components/malla/interfaces/IAlertInfo';

@Component({
  selector: 'app-alerts-in-process-modal',
  templateUrl: './alerts-in-process-modal.component.html',
  styleUrls: ['./alerts-in-process-modal.component.scss'],
})
export class AlertsInProcessModalComponent implements OnInit, OnDestroy {
  @Input() isOpen = false;
  @Input() alert: IAlert;
  @Output() closeModal = new EventEmitter<void>();
  clienteLocalizado = false;
  clienteNoLocalizado = false;
  showResponseSection = true;
  operation = [
    { id: 'confirmar', nombre: 'Confirmar operación' },
    { id: 'rechazar', nombre: 'Rechazar operación' },
  ];
  estadoContacto: string;
  cuentaMultiTitular: boolean = false;

  operationSelected: string;
  formulario: FormGroup;
  timerMinutes: number = 5;
  timerSeconds: number = 0;
  unit!: IUnit;

  isDivVisible: boolean = true;
  routerSuscription: Subscription;
  private timerInterval: any;
  unitId!: string;
  loading = false;
  caseTypes: ICaseType[] = [];
  users;
  filters = {};
  doCaseTimer;
  constructor(
    private socket: SocketService,
    private router: Router,
    private fb: FormBuilder,
    private alertService: AlertService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private readonly unitsService: UnitsService,
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {
    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.getUnit();
          this.getCaseTypes();
        }
      }
    );
  }

  inicializarFormulario() {
    this.formulario = this.fb.group({
      nombre: [''],
      apellido: [''],
      cedula: [''],
      instrumento: [''],
      canal: [''],
      monto: [''],
      nombreCliente: [''],
      telefono: [''],
      observacion: ['', Validators.required],
      estadoContacto: [null, Validators.required],
      respuesta: [null, Validators.required],
      cuentaMultiTitular: [false],
    });

    const alert: IAlert = this.alert;

    if (!alert.nombre || alert.nombre == '') alert.nombre = 'Sin información';
    if (!alert.apellido || alert.apellido == '')
      alert.apellido = 'Sin información';
    if (!alert.cliente || alert.cliente == '')
      alert.cliente = 'Sin información';
    if (!alert.telefono || alert.telefono == '')
      alert.telefono = 'Sin información';

    if (alert) {
      this.formulario.get('nombre').setValue(alert.nombre);
      this.formulario.get('apellido').setValue(alert.apellido);
      this.formulario.get('cedula').setValue(alert.numero_de_identificacion);
      this.formulario.get('nombreCliente').setValue(alert.cliente);
      this.formulario.get('telefono').setValue(alert.telefono);
      this.formulario.get('instrumento').setValue(alert.instrumento);
      this.formulario.get('canal').setValue(alert.canal);
      this.formulario.get('monto').setValue(alert.monto_salio);
    }

    this.formulario.get('estadoContacto').valueChanges.subscribe((value) => {
      this.onEstadoContactoChange();
      if (value === '1') {
        this.formulario.get('respuesta').setValidators([Validators.required]);
        this.formulario.get('respuesta').updateValueAndValidity();
      } else if (value === '2') {
        this.dialog
          .open(ConfirmComponent, {
            data: {
              title:
                'El cliente no fue localizado. Se cerrará la ventana automáticamente',
            },
          })
          .afterClosed()
          .subscribe({
            next: (result) => {
              if (result) {
                this.formulario.get('respuesta').clearValidators();
                //alert.status = 'finalized_proceed_refused';
                //aqui modal que cierra
                this.close();
              } else {
                this.formulario.get('respuesta').clearValidators();
                this.formulario.get('estadoContacto').setValue(null);
              }
            },
          });
      }
    });
  }

  get formValid(): boolean {
    return this.formulario.valid;
  }

  ngOnInit(): void {
    console.log('Alerta: ', this.alert);

    this.socket.socket.on('timer_finish_doCase', (data) => {
      if (data.idAnalista == this.userService.currentUser?._id) {
        this.close(true);
      }
    });

    console.log('inicializar');
    this.inicializarFormulario();
    // this.startTimer();

    this.formulario.get('respuesta').valueChanges.subscribe((value) => {
      if (value !== 'rechazar') {
        this.formulario.get('cuentaMultiTitular').setValue(false);
        this.isDivVisible = true;
      } else {
        this.isDivVisible = false;
      }
    });

    this.socket.socket.on(`${this.alert._id}`, (data) => {
      if (data.idAnalista == this.userService.currentUser?._id) {
        this.updateTimerDisplay(data.doCaseTimer);
      }
    });
  }
  ngOnDestroy(): void {
    this.socket.socket.off('case_finished');
    this.socket.socket.off('timer_finish_doCase');

    this.socket.socket.off(`${this.alert._id}`);
  }
  startTimer() {
    this.timerMinutes = 5;
    this.timerSeconds = 0;

    // this.timerInterval = setInterval(() => {
    //   if (this.timerSeconds === 0) {
    //     if (this.timerMinutes === 0) {
    //       this.stopTimer();
    //       this.close(); // Close modal when timer ends
    //     } else {
    //       this.timerMinutes--;
    //       this.timerSeconds = 59;
    //     }
    //   } else {
    //     this.timerSeconds--;
    //   }
    // }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  onCheckboxChange() {
    this.showResponseSection =
      this.clienteLocalizado || this.clienteNoLocalizado;
  }

  close(by_time_end?: boolean) {
    if (!by_time_end)
      this.socket.socket.emit('case_finished', {
        userId: this.userService.currentUser?._id,
        analista: this.userService.currentUser,
        condition: this.formulario.get('cuentaMultiTitular').value,
        localized: this.formulario.get('estadoContacto').value == '1',
        observacion: this.formulario.get('observacion').value,
        refused: this.formulario.get('respuesta').value,
      });
    this.stopTimer();
    this.closeModal.emit();
    this.alertService
      .updateAlert(this.alert._id, {
        aditionalInformation: this.formulario.value,
      })
      .subscribe((res) => {
        console.log('Alert updated successfully:', res);
      });
    this.formulario.reset();

    this.estadoContacto = null;
    this.operationSelected = null;
    this.cuentaMultiTitular = false;

    this.isOpen = false;

    this.alertService.alertProcesFinished.next(this.userService.currentUser);

    setTimeout(() => {
      this.inicializarFormulario();
    }, 300);
  }

  onSave() {
    this.stopTimer();
    this.close();
    // this.socket.socket.emit('case_finished', {
    //   idAnalista: this.userService.currentUser?._id,
    //   analista: this.userService.currentUser,
    // });
    // this.alertService.alertProcesFinished.next(this.userService.currentUser);
    this.alert.status = 'finalized';
    console.log('Alerta con state changed: ', this.alert);
  }
  onEstadoContactoChange() {
    this.showResponseSection = !!this.estadoContacto;
  }
  findUser() {
    this.userService.getUsersByRole(this.caseTypes[0].role).subscribe({
      next: (users) => {
        this.users = users;
      },
    });
  }
  getUnit() {
    this.loading = true;
    this.unitsService.getById(this.unitId).subscribe({
      next: (unit) => {
        this.loading = false;
        this.unit = unit;
      },
    });
  }
  getCaseTypes() {
    this.unitsService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
        caseTypes.forEach((caseType) => {
          this.filters[caseType._id] = false;
        });
      },
    });
  }

  saveAlert() {
    const alert: Partial<IAlert> = {
      creator: this.userService.currentUser._id,
      unit: this.unitId,
      tipo_de_persona: this.alert?.tipo_de_persona,
      numero_de_identificacion: this.alert?.numero_de_identificacion,
      apellido: this.alert?.apellido,
      nombre: this.alert?.nombre,
      oficina: this.alert?.oficina,
      region: this.alert?.region,
      telefono: this.alert?.telefono,
      correo: this.alert?.correo,
      celular: this.alert?.celular,
      cliente: this.alert?.cliente,
      domicilio: this.alert?.domicilio,
      tipo_registro: this.alert?.tipo_registro,
      canal: this.alert?.canal,
      instrumento: this.alert?.instrumento,
      descripcion:
        this.formulario.get('observacion').value ?? this.alert.descripcion,
      monto_salio: this.alert?.monto_salio,
      status: 'refused',
      code: this.alert?.code,
      _id: this.alert._id,
    };
    // console.log('Alertaaaaaa: ', alert.status);
    // this.alertService.vuExample(alert).subscribe((res) => {
    //   console.log(res);
    //   this.snackbar.open(`Alertas en proceso creada`, `Ok`, { duration: 1000 });
    // });

    if (this.formulario.get('cuentaMultiTitular').value)
      this.alertService.remmitAlertAn(alert).subscribe(
        (res) => {
          console.log(res);
          this.snackbar.open(`Alerta remitida a unidad Analisis`, `Ok`, {
            duration: 5000,
          });
        },
        (err) => {
          console.error('Error al crear alerta:', err);
          this.snackbar.open(`Error al crear la alerta`, `Cerrar`, {
            duration: 5000,
          });
        }
      );
    else if (this.formulario.get('respuesta').value === 'rechazar')
      this.alertService
        .remmitAlertCSA(alert._id, this.userService.currentUser._id)
        .subscribe(
          (res) => {
            console.log(res);
            this.snackbar.open(
              `Alertas remitida a unidad Casos sin Asignar`,
              `Ok`,
              {
                duration: 5000,
              }
            );
          },
          (err) => {
            console.error('Error al crear alerta:', err);
            this.snackbar.open(`Error al crear la alerta`, `Cerrar`, {
              duration: 3000,
            });
          }
        );

    this.stopTimer();
    this.close();
  }

  ///////////
  updateTimerDisplay(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    this.doCaseTimer = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
      secs
    )}`;
  }

  // Agrega un cero a la izquierda si el número es menor a 10
  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
}
